document.addEventListener("DOMContentLoaded", () => {
  if (window.innerWidth < 750) {
    const elements = document.querySelectorAll(
      ".enable_slider_mobile__true"
    );
    elements.forEach((element) => {
      new Flickity(element, {
        adaptiveHeight: true,
        prevNextButtons: false,
        pageDots: true,
        wrapAround: true,
      });
    });
  }
});